import * as Commons from "oc-commons/Commons";
import _ from "lodash";

/**
 * AbstractRichMetadata reichert clientseitig die vom Backend gelesenen Metadata an.
 * Die Klasse sollte von der App abgeleitet und um projektspezifische Funktionalität ergänzt werden.
 *
 * UseCases zur Initialisierungzeit:
 *   - Datenstrukturen für schnelleren Zugriff aufbauen
 *   - Validierungen vornehmen
 *
 * UsesCases zur Laufzeit:
 *   - Facade für den einfachen Zugriff auf Metadata
 *
 * Generell werden die Objekte der Metadata transformiert, es können aber auch eigene Datenstrukturen aus
 * Metadata extrahiert und in RichMetadata gehalten werden.
 *
 * AbstractRichMetadata dient dazu, zum einen das концепt als solches vorzugeben, und
 * den generalisierbaren Teil abzubilden.
 *
 * Auf die Instanz von RichMetadata kann über APP.richMetadata zugegriffen werden.
 */
export class AbstractRichMetadata {
  [key: string]: any;
  metadata: any;
  metadataPlain: any;

  constructor(metadata: any = APP.metadata, metadataPlain: any = _.cloneDeep(APP.metadataPlain)) {
    this.metadata = metadata;
    this.metadataPlain = metadataPlain;
    if (this.metadata) {
      this.initPrimaryKeyFindMethods();
    }
  }

  ///////////////////////////////////////////////////////////////////
  // Zugriffsmethoden
  ///////////////////////////////////////////////////////////////////

  /***
   * kann zum Beispiel im abgeleiteten Konstruktor aufgerufen werden um für eine bestimmte Tabelle eine find Funktion zu generieren
   * @param tableName
   * @param keyColumn
   * @example
   *  this.initTableLookup('Model','Key'); // in Konstruktor der RichMetadata
   *   APP.richMetadata.findModel('modelkey'); // im Code
   * }
   */
  initTableLookup(tableName: string, ...keyColumns: string[]): void {
    if (this["find" + tableName]) {
      return;
    }
    if (keyColumns.length == 1) {
      const keyColumn = keyColumns[0];
      this["find" + tableName] = Commons.cacheIdentity((keyColumnValue: any) =>
        this.metadata[tableName].find((row: any) => row[keyColumn] == keyColumnValue),
      );
    } else {
      this["find" + tableName] = Commons.cache((...keyColumnValues: any[]) =>
        this.metadata[tableName].find((row: any) =>
          keyColumns.every((c, i) => {
            return row[c] == keyColumnValues[i];
          }),
        ),
      );
    }
  }

  /**
   * erzeugt für alle Tabellen find-Methoden, die einen PrimaryKey  haben
   */
  initPrimaryKeyFindMethods(): void {
    APP.metamodel.tables
      .filter((table: any) => this.metadata[table.name] != null)
      .forEach((table: any) => {
        const primary = table.columns.find((c: any) => c.primaryKey);
        if (primary) {
          this.initTableLookup(table.name, primary.name);
        }
        if (!Commons.isEmpty(table.uniqueIndex)) {
          this.initTableLookup(table.name, ...table.uniqueIndex.filter((s: string) => s != "App"));
        }
      });
  }
}
